$(document).ready(function () {
    const gallery = $('.entertainment-detail__slider');

    if (gallery.length > 0) {
        gallery.slick({
            slidesToShow: 1,
            fade: true,
            arrows: true,
        });
    }

    gallery.on('click', '.entertainment-detail__slide', function (e) {
        e.preventDefault();

        const slickInstance = gallery.slick('getSlick');
        const totalSlides = slickInstance.slideCount;
        const $slide = $(this).closest('.slick-slide');
        const dataIndex = $slide.data('slick-index');

        let trueIndex;
        if (dataIndex < 0) {
            trueIndex = totalSlides + dataIndex;
        } else if (dataIndex >= totalSlides) {
            trueIndex = dataIndex % totalSlides;
        } else {
            trueIndex = dataIndex;
        }

        const items = gallery.find('.entertainment-detail__slide').map(function () {
            return {
                src: $(this).attr('href'),
                opts: {
                    caption: $(this).find('img').attr('alt') || ''
                }
            };
        }).get();

        $.fancybox.open(items, {}, trueIndex);

        return false;
    });

});